import { render, staticRenderFns } from "./BlockDocument.vue?vue&type=template&id=5eb943ea&"
import script from "./BlockDocument.vue?vue&type=script&lang=ts&"
export * from "./BlockDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports